import React, { Component } from "react";
import { Container, Button, ModalFooter, ModalBody, Input } from "reactstrap";
import RequestManager from "../../singletons/RequestManager";
export default class InvoiceBill extends Component {
  constructor(props) {
    super(props);
    this.invoiceBillNumber = "";
    this.state = {};
  }
  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0, alignItems: "center" }}>
        <ModalBody>
          <h5 style={{ margin: 10 }}> Store Invoice number</h5>
        </ModalBody>
        <ModalFooter>
          <div>
            <Input
              type="text"
              placeholder="Enter Invoice Number"
              onChange={event => {
                this.invoiceBillNumber = event.target.value;
              }}
            />
            <Button
              color="danger"
              style={{
                margin: 10,
                paddingLeft: 25,
                paddingRight: 25
              }}
              onClick={() => {
                this.props.goBack();
              }}
            >
              Cancel
            </Button>
            <Button
              color="success"
              style={{ paddingLeft: 25, margin: 10, paddingRight: 25 }}
              onClick={() => {
                if (this.invoiceBillNumber.length > 1) {
                  this.updateOrderStatus();
                } else {
                  alert("Atleast one character should be their");
                }
              }}
            >
              Confirm
            </Button>
          </div>
        </ModalFooter>
      </Container>
    );
  }

  updateOrderStatus = async () => {
    let requestManager = new RequestManager();
    let params = {
      input: {
        id: this.props.order.node.id,
        invoiceNo: this.invoiceBillNumber
      }
    };
    console.log("params11", JSON.stringify(params));
    let response = requestManager.getResponseFromPredefinedQuery(
      "updateOrder",
      params
    );

    console.log("updateOrder Bill number", JSON.stringify(response));
    this.props.goBack();
  };
}



// WEBPACK FOOTER //
// ./src/components/DetailedOrderCard/InvoiceBill.js